import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../../lib/utils';
interface LogoProps {
  className?: string;
  inverted?: boolean;
  size?: 'sm' | 'lg' | 'xl';
}
// Real brand assets supplied by the client
const LOGO_LIGHT = 'https://cdn.magicpatterns.com/uploads/1qhh85p8Wyy3SWzDwgQEdA/c18858da-37bc-40c4-a5ba-5303f9733c07_(1).png';
const LOGO_INVERTED = 'https://cdn.magicpatterns.com/uploads/eLKhCkcSW2zJpdzVdkikvf/La-logo.png';
export function Logo({
  className,
  inverted = false,
  size = 'sm'
}: LogoProps) {
  const heights = size === 'xl' ? 'h-40 md:h-48' : size === 'lg' ? 'h-20 md:h-24' : 'h-12 md:h-14';
  return <Link to="/" aria-label="L.A Property Law and Conveyancing, home" className={cn('group inline-flex items-center leading-none', className)} data-id="element-476" data-mp="aiz6gf4i7tex">
      <img src={inverted ? LOGO_INVERTED : LOGO_LIGHT} alt="L.A Property Law and Conveyancing" className={cn('w-auto object-contain', heights)} loading="eager" decoding="async" data-id="element-477" data-mp="mmh1tfzs1pz" />
    </Link>;
}